import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Import helpers
import { getErrorStatus } from 'helpers/error_code_api';

// Import components
import { Alert } from 'components/elements';

const LoginError = ({ authError: { isError, errorCode, status, message } }) => {
	// Check login error status
	const errorStatus = React.useMemo(() => {
		return message || getErrorStatus(status, errorCode);
	}, [status, errorCode, message]);

	return (
		isError && (
			<Alert testid="login-form-error" text={errorStatus} closeBtn={false} />
		)
	);
};

LoginError.propTypes = {
	authError: PropTypes.shape({
		isError: PropTypes.bool.isRequired,
		message: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		status: PropTypes.number.isRequired
	}).isRequired
};

const mapStateToProps = ({ auth }) => ({
	authError: auth.authError
});

export default connect(mapStateToProps)(LoginError);
